module.exports = __webpack_public_path__ + "img/2.3a5c9fed.jpg";